import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { monolithApi } from '@/utils/api';

type SwitchAccountRequest = {
  slug?: string;
};

type UseSwitchAccountResult = UseMutationResult<AxiosResponse, AxiosError, SwitchAccountRequest>;

const useSwitchAccount = (): UseSwitchAccountResult =>
  useMutation<AxiosResponse, AxiosError, SwitchAccountRequest>({
    mutationFn: (data) => monolithApi.post('/me/select_account', data),
  });

export default useSwitchAccount;
